// extracted by mini-css-extract-plugin
module.exports = {"input-points__description":"styles_input-points__description__IT2Gj","point":"styles_point__1VBcZ","symbol":"styles_symbol__3ZpN1"};